import { zIndex } from 'common/constants'
import styled from 'styled-components'

export const StyleLoader = styled.div``

export interface IProps {
  variant?: string
  overlay?: boolean
}

interface IStyledLoaderProps {
  overlay?: boolean
}

export const StyledLoader = styled.div<IStyledLoaderProps>`
  ${({ overlay }) =>
    overlay &&
    ` position: absolute;
      left: calc(50% - 1rem);
      top: calc(50% - 1rem);
    `}
`

export const StyledPageLoader = styled.div<IProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.loader};
`

export interface ISpinnerProps {
  size?: string
  color?: string
}

export const StyleCustomLoader = styled.div<ISpinnerProps>`
  color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  fill: ${({ theme }) => theme.colors.InfinitiOnlyColor};

  .custom-spinner {
    position: relative;
    animation: my-custom 1s linear infinite;
  }

  @-webkit-keyframes my-custom {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes my-custom {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
